import React, { useEffect, useState, useContext, useRef } from "react";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";
import { useNavigate, useLocation, Outlet } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAddressCard } from "@fortawesome/free-regular-svg-icons";
import { faList, faPlusSquare } from "@fortawesome/free-solid-svg-icons";
import "./Suppliers.css";
import ListWithFilters from "../ListWithFilters/ListWithFilters";
import AddSupplierModal from "./AddSupplierModal";
import SocketContext from "../../contexts/SocketContext";
import SupplierCards from "./SupplierCards";
import { gsap } from "gsap";

const Suppliers = () => {
  // General
  const axiosPrivate = useAxiosPrivate();
  const navigate = useNavigate();
  const location = useLocation();

  // Socket
  const { socket } = useContext(SocketContext);

  // States to hold Data and ListData
  const [data, setData] = useState();
  const [listdata, setListData] = useState();
  const [reloaddata, setReloaddata] = useState(false);

  // View State
  const [viewlist, setViewlist] = useState(true);

  // Show Hide
  const [showSupDetails, setShowSupDetails] = useState(false); //customer details
  const [showAddSupplierModal, setShowAddSupplierModal] = useState(false); //add customer modal

  // Success Message
  const successMSGRef = useRef();
  const [showsuccess, setShowsuccess] = useState(false);
  const [successMSG, setSuccessMSG] = useState("");

  // Selected Supplier
  const [selectedSupplier, setSelectedSupplier] = useState();

  // Card View
  const [supplierfilter, setSupplierfilter] = useState("");
  const [supcarddata, setSupcarddata] = useState();

  // Join and Leave Suppliers Room
  useEffect(() => {
    socket.emit("joinsuppliersroom");
    return () => {
      socket.emit("leavesuppliersroom");
    };
  }, []);

  // Load all suppliers and set them in Data
  useEffect(() => {
    let isMounted = true;
    const controller = new AbortController();
    const getSuppliers = async () => {
      try {
        const response = await axiosPrivate.get("api/suppliers");
        isMounted && setListData(response.data);
        isMounted && setData(response.data);
      } catch (err) {
        navigate("/login", { state: { from: location }, replace: true });
      }
    };
    getSuppliers();
    return () => {
      isMounted = false;
      controller.abort();
    };
  }, [reloaddata]);

  // Filter Card Data
  useEffect(() => {
    if (listdata && listdata.length > 0) {
      if (supplierfilter) {
        let temp = listdata.filter(
          (item) =>
            item.companyCode?.toLowerCase().includes(supplierfilter?.toLowerCase()) ||
            item.companyName?.toLowerCase().includes(supplierfilter?.toLowerCase()) ||
            item.country?.toLowerCase().includes(supplierfilter?.toLowerCase()) ||
            item.city?.toLowerCase().includes(supplierfilter?.toLowerCase()) ||
            item.region?.toLowerCase().includes(supplierfilter?.toLowerCase())
        );
        setSupcarddata(temp);
      } else {
        setSupcarddata(listdata);
      }
    }
  }, [supplierfilter, listdata]);

  // Select Supplier Function to pass to List With Filters
  const selectSupplier = (item) => {
    setShowSupDetails(true);
    setSelectedSupplier(item);
    if (location.pathname === "/admin/suppliers") {
      navigate("/admin/suppliers/supplierdetails", { state: { from: location }, replace: true });
    }
  };

  // Socket Functions
  const receivednewsupplier = (newitem) => {
    socket && setListData((prev) => [...prev, newitem]);
  };
  const receivedupdatesupplier = (item) => {
    socket &&
      setListData((prev) => {
        let ind = prev.findIndex((it) => it.supplierID === item.supplierID);
        if (ind !== -1) {
          return [...prev.slice(0, ind), item, ...prev.slice(ind + 1, prev.length)];
        } else return [...prev];
      });
  };
  const receiveddeletesupplier = (item) => {
    if (socket) {
      console.log(item);
      if (selectedSupplier) {
        console.log(selectedSupplier.supplierID);
      }
      if (selectedSupplier && selectedSupplier.supplierID === item) {
        setShowSupDetails(false);
      }
      setListData((prev) => {
        let ind = prev.findIndex((it) => it.supplierID === item);
        if (ind !== -1) {
          return [...prev.slice(0, ind), ...prev.slice(ind + 2, prev.length)];
        } else return [...prev];
      });
    }
  };

  // Suscribe to Socket Events
  useEffect(() => {
    socket.on("enewsupplier", (newitem) => {
      receivednewsupplier(newitem);
    });
    // socket.on("edeleteprodspec", (id) => {
    //   receiveddelspec(id);
    // });
    socket.on("eupdatesupplier", (item) => {
      receivedupdatesupplier(item);
    });
    socket.on("edeletesupplier", (item) => {
      receiveddeletesupplier(item);
    });
    return () => {
      socket.off("enewsupplier");
      // socket.off("edeleteprodspec");
      socket.off("eupdatesupplier");
      socket.off("edeletesupplier");
    };
  }, [socket]);

  // Show Success Msg
  const onSPMComplete = () => {
    setSuccessMSG(null);
  };
  useEffect(() => {
    const elem = successMSGRef.current;
    if (successMSG) {
      gsap.fromTo(elem, { opacity: 0.5, top: "-20px" }, { opacity: 1, top: 0, duration: 0.1, ease: "power2.in" });
      gsap.fromTo(
        elem,
        { opacity: 1 },
        {
          opacity: 0,
          duration: 3,
          ease: "power2.inOut",
          onComplete: onSPMComplete,
        }
      );
    }
  }, [showsuccess]);

  return (
    <div className='supplierList'>
      <AddSupplierModal
        show={showAddSupplierModal}
        setShow={setShowAddSupplierModal}
        reloaddata={reloaddata}
        setReloaddata={setReloaddata}
      />
      <div className='slheader'>
        <div className='slsubheader'>
          {viewlist && <h1>Supplier List</h1>}
          {!viewlist && <h1>Supplier Cards</h1>}
        </div>
        <div className='success-msg' ref={successMSGRef}>
          {successMSG}
        </div>
        <div className='viewsuppliersas'>
          <p>View as:</p>
          <FontAwesomeIcon
            className='viewsupicon'
            icon={faList}
            onClick={(e) => {
              setViewlist(true);
            }}
          />
          <FontAwesomeIcon
            className='viewsupicon'
            icon={faAddressCard}
            onClick={(e) => {
              setViewlist(false);
            }}
          />
          <FontAwesomeIcon
            className='viewsupicon'
            icon={faPlusSquare}
            onClick={(e) => {
              setShowAddSupplierModal(true);
            }}
          />
        </div>
      </div>
      {!viewlist && (
        <input
          className='suppliercardsearch'
          placeholder='search'
          type='text'
          onChange={(e) => setSupplierfilter(e.target.value)}
        />
      )}
      <div className='supplierListContent'>
        {!viewlist && (
          // CARD LIST VIEW
          <SupplierCards data={supcarddata} onCardClick={selectSupplier} />
        )}
        {viewlist && (
          //SUPPLIER LIST VIEW
          <ListWithFilters
            data={listdata}
            columns={["companyCode", "companyName", "city", "country", "region"]}
            rowID={"supplierID"}
            sortable={true}
            sortDirections={["ASC", "NON", "NON", "ASC", "NON"]}
            size={["M", "L", "M", "M", "M"]}
            onRowClick={selectSupplier}
            placeHolders={true}
            placeHolderList={["Code", "Company Name", "City", "Country", "Region"]}
            rowIndex={true}
          />
        )}
        {selectedSupplier && (
          <Outlet
            context={[
              showSupDetails,
              selectedSupplier,
              setSelectedSupplier,
              setReloaddata,
              reloaddata,
              setShowsuccess,
              setSuccessMSG,
            ]}
          />
        )}
      </div>
    </div>
  );
};

export default Suppliers;
